export default [{
  path: '/operation',
  name: 'operation',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/kpp/operation/index')
}]
